import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-[#000db5] flex items-center justify-center text-center px-4">
      <div>
        <div className="text-[200px] font-black text-slate-400 leading-none">404</div>
        <h1 className="text-4xl font-black text-white mb-4 mt-10">Page Not Found</h1>
        <p className="text-white/70 mb-8">The page you're looking for doesn't exist</p>
        <Link to={'/'} className="bg-white text-[#000db5] px-8 py-4 rounded-full font-bold hover:shadow-xl transition-all">
          Go Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
